export const PRIMARY_COLOR = "#1A21BA";
export const RED_COLOR = "#EB5757";
export const DARK_ORANGE = "#ff8c00";
export const APP_BLUE = "#0050c8";